import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ReadonlyHttpApiCollectionRepository } from '@softline/core';
import { SOFTLINE_API_ABC_ANALYSIS_BASE_MEASURES } from '../abc-analysis.api';
import { AbcAnalysisBaseMeasureDto } from '../types/abc-analysis-base-measure';

@Injectable()
export class AbcAnalysisBaseMeasuresRepository extends ReadonlyHttpApiCollectionRepository<
  AbcAnalysisBaseMeasureDto[]
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_ABC_ANALYSIS_BASE_MEASURES);
  }
}
